import api from './api';

// Tariff codes and fees. Codes / units / rules are shared (omniMain) and are a
// PLACEHOLDER for now, not SAMA's; fee schedules (rand per unit) are the practice's.
const tariffService = {
  status: () => api.get('/tariffs/status').then((r) => r.data),
  search: (q, { types, limit = 12 } = {}) =>
    api.get('/tariffs/search', { params: { q, limit, types: types?.join(',') } }).then((r) => r.data.results || []),
  codes: () => api.get('/tariffs/codes').then((r) => r.data.codes || []),
  // { codes: [code], facts: { duration_minutes, age_years, bmi, emergency, prone }, scheme_id }
  calculate: (payload) => api.post('/tariffs/calculate', payload).then((r) => r.data),
  schedules: () => api.get('/tariffs/fee-schedules').then((r) => r.data.schedules || []),
  addSchedule: (payload) => api.post('/tariffs/fee-schedules', payload).then((r) => r.data.schedules || []),
  updateSchedule: (id, payload) => api.put(`/tariffs/fee-schedules/${id}`, payload).then((r) => r.data.schedules || []),
  removeSchedule: (id) => api.delete(`/tariffs/fee-schedules/${id}`).then((r) => r.data.schedules || []),
};

export default tariffService;
